import { render } from "./OrderEdit.vue?vue&type=template&id=e160d5b0&scoped=true&ts=true"
import script from "./OrderEdit.vue?vue&type=script&lang=ts"
export * from "./OrderEdit.vue?vue&type=script&lang=ts"

import "./OrderEdit.vue?vue&type=style&index=0&id=e160d5b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e160d5b0"]])

export default __exports__